import React from 'react';
import Image from 'next/image'
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";

export interface Props {
    uri?: any,
    src?: any,
    name?: string,
    size?: number,
    dark?: boolean,
    circled?: true
    alt?: string
    circleSize?: number
}

const whiteToMainFilter = "invert(35%) sepia(7%) saturate(4062%) hue-rotate(62deg) brightness(66%) contrast(100%)"


const CCOSvg = (props: Props) => {
    return (
        <Box
            component="span"
            sx={{
                display: 'flex',
                justifyContent: 'center'
            }}>
            {props.circled ? <Avatar sx={{
                    bgcolor: props.dark ? 'primary.contrastText' : 'primary.main',
                    width: props.circleSize ? props.circleSize : props.size ? props.size * 2 : 100,
                    height: props.circleSize ? props.circleSize : props.size ? props.size * 2 : 100,
                }}>
                    <Image loading={'lazy'}
                           alt={props.alt ? props.alt : props.name ? props.name : ''}
                           src={props.uri ? `/media${props.uri}` : props.src}
                           width={props.size ?? 50}
                           height={50}
                           about={''}
                           style={{
                               color: "primary.contrastText",
                               filter: props.dark ? whiteToMainFilter : undefined
                           }}
                    />
                </Avatar> :
                <Image loading={'lazy'}
                       alt={props.alt ? props.alt : props.name ? props.name : ''}
                       src={props.uri ? `/media${props.uri}` : props.src}
                       width={props.size ?? 50}
                       height={50}
                       about={''}
                       style={{
                           color: "primary.contrastText",
                           filter: props.dark ? whiteToMainFilter : undefined
                       }}
                />
            }


        </Box>
    );

};

export default CCOSvg;
